var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-2xl font-bold"},[_vm._v("Events, Feedback & AI Models")]),_c('p',{staticClass:"text-sm text-muted-foreground"},[_vm._v(" Review AI-triggered events, provide feedback, and help improve system accuracy. ")])])
}]

export { render, staticRenderFns }